/** Rasterize trusted app artwork for document readers that cannot display embedded SVGs. */
export async function svgToPngDataUrl(svg: string): Promise<string> {
  const image = new Image()
  image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
  await image.decode()

  const canvas = document.createElement('canvas')
  // Eight times the 14px display size keeps the small icon sharp in print.
  canvas.width = 112
  canvas.height = 112
  const context = canvas.getContext('2d')
  if (!context) throw new Error('Unable to prepare the case treatment icon')

  context.drawImage(image, 0, 0, canvas.width, canvas.height)
  return canvas.toDataURL('image/png')
}
